import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { downloadExcel, getMoqsDiscounts } from '@/api/moqs-discounts';
import Pagination from '@/components/Pagination/index.vue';
import { getQuery, formatJson } from '@/utils/index';
import { exportJson2Excel } from '@/utils/excel';
import Enabled from '@/components/Enabled/index.vue';
import { getDealersRoles } from '@/api/dealers-roles';
import { searchProducts } from '@/api/products';
import { getBranches } from '@/api/locations/branches';
import { getRanges } from '@/api/ranges';
let default_1 = class extends Vue {
  constructor() {
    super(...arguments);
    this.isReadOnly = false;
    this.tableKey = 0;
    this.total = 0;
    this.list = [];
    this.listLoading = true;
    this.downloadLoading = false;
    this.productIdRowsCount = {};
    this.productList = [];
    this.rangeList = [];
    this.moqId = 0;
    this.roleList = [];
    this.branchList = [];
    this.listQuery = {
      page: 1,
      limit: 10,
      enabled: true,
      moqId: this.moqId,
      branchId: undefined,
      rangeId: undefined,
      dealersRoleId: undefined,
      productId: undefined,
      sort: ['productId,ASC', 'productsVariation.name,ASC', 'minimumQuantity,ASC'],
      filter: {
        enabled: '$eq',
        moqId: '$eq',
        dealersRoleId: '$eq',
        productId: '$eq',
        branchId: '$eq',
        rangeId: '$eq'
      }
    };
    this.enableTypeOptions = [{
      key: true,
      value: 'Enable'
    }, {
      key: false,
      value: 'Disabled'
    }];
  }
  activated() {
    this.moqId = parseInt(this.$route.params && this.$route.params.moqId);
    this.listQuery = {
      ...this.listQuery,
      ...this.$route.query
    };
    this.getList();
    // fetch dealers roles
    this.fetchDealersRoles();
    this.fetchBranches();
    this.fetchRanges();
  }
  async getList() {
    try {
      this.listLoading = true;
      this.listQuery.moqId = this.moqId;
      if (this.listQuery.dealersRoleId || this.listQuery.branchId || this.listQuery.productId || this.listQuery.rangeId) {
        const data = await getMoqsDiscounts(getQuery(this.listQuery));
        /* find out product id rows count & assign to find product id row */
        this.productIdRowsCount = {};
        data.data.forEach(item => {
          if (this.productIdRowsCount[item.productId]) {
            this.productIdRowsCount[item.productId] += 1;
          } else {
            this.productIdRowsCount[item.productId] = 1;
          }
        });
        this.list = data.data;
        this.total = data.total;
      } else {
        this.list = [];
        this.total = 0;
      }
      this.listLoading = false;
    } catch (error) {
      this.listLoading = false;
    }
  }
  async fetchBranches() {
    this.branchList = await getBranches(getQuery({
      enabled: true,
      sort: 'name,ASC',
      filter: {
        enabled: 'eq'
      }
    }));
  }
  async fetchRanges() {
    this.rangeList = await getRanges(getQuery({
      enabled: true,
      sort: 'name,ASC',
      filter: {
        enabled: '$eq'
      }
    }));
  }
  handleFilter() {
    this.listQuery.page = 1;
    if (!this.listQuery.dealersRoleId) {
      this.listQuery.productId = undefined;
    }
    this.getList();
  }
  async fetchDealersRoles() {
    this.roleList = await getDealersRoles(getQuery({
      enabled: true,
      sort: 'name,ASC',
      filter: {
        enabled: '$eq'
      }
    }));
  }
  async fetchProductList(query) {
    try {
      if (query.length > 2) {
        this.productList = await searchProducts(getQuery({
          keyword: query
        }));
      }
    } catch (err) {} // eslint-disable-line  no-empty
  }
  sortChange(data) {
    this.handleFilter();
  }
  async handleExcelDownload() {
    this.downloadLoading = false;
    try {
      const query = this.listQuery;
      const blob = await downloadExcel({
        query
      });
      // Create a blob URL for the Excel file
      const url = window.URL.createObjectURL(blob);
      // Create a temporary link element
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'moqs-discount.xlsx');
      document.body.appendChild(link);
      // Simulate click to trigger download
      link.click();
      // Clean up
      window.URL.revokeObjectURL(url);
      document.body.removeChild(link);
    } catch (error) {
      console.error('Error downloading Excel:', error);
      this.$message.error('Error downloading Excel');
    } finally {
      // Reset loading state
      this.downloadLoading = false;
    }
  }
  doProductRowSpan(args) {
    const {
      row,
      column,
      rowIndex,
      columnIndex
    } = args;
    if ([0, 4].includes(columnIndex)) {
      // check row - 1 has same product id
      if (rowIndex > 0) {
        const prevRow = this.list[rowIndex - 1];
        if (prevRow.productId === row.productId) {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
      return {
        rowspan: this.productIdRowsCount[row.productId],
        colspan: 1
      };
    }
    return 0;
  }
  handleDownload() {
    this.downloadLoading = true;
    const tHeader = ['id', 'fullname', 'email', 'contact', 'role'];
    const filterVal = ['id', 'fullName'];
    const data = formatJson(filterVal, this.list);
    exportJson2Excel(tHeader, data, this.$tc('route.userManagement.users.title'));
    this.downloadLoading = false;
  }
};
default_1 = __decorate([Component({
  name: 'MoqsDiscountList',
  components: {
    Pagination,
    Enabled
  }
})], default_1);
export default default_1;